import Script from 'next/script';
import { useViewport } from 'hooks/3catinfo/useViewport';

const AppsFlyerBanner = () => {
    const { isMobile } = useViewport();
    if (!isMobile) return <></>;

    return (
        <Script id='appsflyer-snippet' strategy='afterInteractive'>
            {`!function(t,e,n,s,a,c,i,o,p){
                t.AppsFlyerSdkObject=a,
                t.AF=t.AF||function(){
                    (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))
                },
                t.AF.id=t.AF.id||i,
                t.AF.plugins={},
                o=e.createElement(n),
                p=e.getElementsByTagName(n)[0],
                o.async=1,
                o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
                p.parentNode.insertBefore(o,p)
            }(window,document,"script",0,"AF","banners",{banners: {key: "e62eea41-9dc4-4b25-88da-8772ec327171"}}); 
            AF('banners', 'showBanner')`}
        </Script>
    );
};

export default AppsFlyerBanner;
